"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
const use_clickable_props_1 = require("@uxf/core-react/hooks/use-clickable-props");
const classes_1 = require("@uxf/core/constants/classes");
const cx_1 = require("@uxf/core/utils/cx");
const react_1 = __importStar(require("react"));
exports.Radio = (0, react_1.forwardRef)((props, ref) => {
    var _a, _b, _c;
    const onChange = props.onChange;
    const onClick = onChange ? () => onChange(props.value) : undefined;
    const clickableProps = (0, use_clickable_props_1.useClickableProps)({
        "aria-checked": props.checked,
        "aria-disabled": props.isDisabled,
        "aria-invalid": props.isInvalid,
        "aria-readonly": props.isReadOnly,
        "aria-required": props.isRequired,
        className: (0, cx_1.cx)("uxf-radio", `uxf-radio--size-${(_a = props.size) !== null && _a !== void 0 ? _a : "default"}`, props.isDisabled && classes_1.CLASSES.IS_DISABLED, props.isFocused && classes_1.CLASSES.IS_FOCUSED, props.isInvalid && classes_1.CLASSES.IS_INVALID, props.isReadOnly && classes_1.CLASSES.IS_READONLY, props.checked && classes_1.CLASSES.IS_SELECTED, props.className),
        onBlur: props.onBlur,
        onClick,
        onFocus: props.onFocus,
        role: "radio",
        style: props.style,
        tabIndex: props.isReadOnly ? -1 : undefined,
    });
    const innerClassName = "uxf-radio__inner";
    return (react_1.default.createElement("span", { ...clickableProps, ref: ref }, (_c = (_b = props.renderContent) === null || _b === void 0 ? void 0 : _b.call(props, innerClassName, props.checked, props.value)) !== null && _c !== void 0 ? _c : react_1.default.createElement("span", { className: innerClassName })));
});
exports.Radio.displayName = "UxfUiRadio";
